<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{ $route.meta.title }}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{path: '/'}">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">搜索</template>

      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">

        <div class="re-el-form__flex">
          <el-form-item label="账户名称"
                        key="company_name"
                        prop="company_name">
            <el-input style="width: 100%;"
                      v-model="search.company_name"
                      clearable
                      placeholder="请输入账户名称搜索">
            </el-input>
          </el-form-item>

          <el-form-item label="禁用状态"
                        key="is_disabled"
                        prop="is_disabled">
            <el-select v-model="search.is_disabled"
                       clearable
                       class="width-max">
              <el-option v-for="(label, key) in {1: '已禁用', 0: '启用中'}"
                         :key="key"
                         :label="label"
                         :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>

        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <div class="margin b15">
        <el-button type="primary"
                   @click="createCompanyBank"
                   size="small">添加对公账户
        </el-button>
        <el-button type="primary"
                   @click="batchCreateCompanyBank"
                   size="small">批量添加/修改
        </el-button>
        <el-button type="primary"
                   size="small"
                   @click="onExportSearch()">按搜索结果导出
        </el-button>
      </div>

      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         key="id"
                         label="ID"></el-table-column>
        <el-table-column prop="company_name"
                         key="company_name"
                         label="账户名称"></el-table-column>
        <el-table-column prop="bank_account"
                         key="bank_account"
                         label="银行账号"></el-table-column>
        <el-table-column prop="bank"
                         key="bank"
                         label="开户银行支行"></el-table-column>
        <el-table-column prop="bank_headquarters"
                         key="bank_headquarters"
                         label="开户银行总行"></el-table-column>
        <el-table-column prop="remark"
                         key="remark"
                         label="备注"></el-table-column>
        <el-table-column prop="is_disabled"
                         key="is_disabled"
                         label="禁用状态">
          <template slot-scope="scope">
            {{ scope.row.is_disabled > 0 ? '已禁用' : '启用中' }}
          </template>
        </el-table-column>

        <el-table-column fixed="right"
                         label="操作"
                         :key="`operation`"
                         width="150">
          <template slot-scope="scope">
            <el-button type="primary"
                       @click="editCompanyBank(scope.row.id)"
                       size="mini">修改
            </el-button>
            <el-button :type="scope.row.is_disabled > 0 ? 'success' : 'danger'"
                       @click="changeStatus(scope.row)"
                       size="mini">{{ scope.row.is_disabled > 0 ? '启用' : '禁用' }}
            </el-button>
<!--            <el-button type="danger"-->
<!--                       size="mini"-->
<!--                       @click="onDelete(scope.row.id)">删除-->
<!--            </el-button>-->
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <company-bank-form-dialog :visible="dialogVisible"
                              :id="dialogId"
                              :title="dialogTitle"
                              @closeDialog="closeDialog"
                              @closeDialogRefresh="closeDialogRefresh">
    </company-bank-form-dialog>

  </div>
</template>

<script>
import table from '@core/mixins/table'
import CompanyBankFormDialog from '@views/company-bank-account/components/CompanyBankFormDialog'

export default {
  mixins: [table],
  components: {
    CompanyBankFormDialog
  },
  data () {
    return {
      search: {
        is_disabled: null,
        company_name: null,
      },
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0,
      },
      dialogTitle: '',
      dialogVisible: false,
      dialogId: 0,
      exportHeader: [
        {
          key: 'id',
          text: 'ID'
        },
        {
          key: 'company_name',
          text: '账户名称'
        },
        {
          key: 'remark',
          text: '备注'
        },
        {
          key: 'bank_account',
          text: '银行账号'
        },
        {
          key: 'bank',
          text: '开户银行支行'
        },
        {
          key: 'bank_headquarters',
          text: '开户银行总行'
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     *
     */
    getTableData (params) {
      return request.page('getCompanyBankAccountTable', params)
    },
    createCompanyBank () {
      return request.loading('createCompanyBankAccount', {'is_test_permission': 1}).then(_ => {
        this.dialogTitle = '添加对公账户'
        this.dialogVisible = true
        this.dialogId = 0
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
        return false
      })
    },
    batchCreateCompanyBank () {
      request.loading('createCompanyBankAccount', {'is_test_permission': 1}).then(_ => {
        this.$router.push('/company-bank-account/create/batch')
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    editCompanyBank (id) {
      request.loading('updateCompanyBankAccount', {id, 'is_test_permission': 1}).then(_ => {
        this.dialogTitle = '修改对公账户'
        this.dialogVisible = true
        this.dialogId = id * 1
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    changeStatus (row) {
      const hasDisabled = row.is_disabled > 0
      const uri = hasDisabled ? 'enableCompanyBankAccount' : 'disableCompanyBankAccount'
      const msg = hasDisabled ? '启用' : '禁用'
      request.loading(uri, {id: row.id, 'is_test_permission': 1}).then(_ => {
        this.$confirm('确定要' + msg + '吗？', '警告', {type: 'warning'}).then(_ => {
          request.common(uri, {id: row.id}).then(_ => {
            this.$message.success(msg + '成功')
            this.onSearch()
          })
        })
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    onDelete (id) {
      let uri = 'delCompanyBankAccountById'
      request.loading(uri, {id, 'is_test_permission': 1}).then(_ => {
        this.$confirm('确定要删除吗？', '警告', {type: 'warning'}).then(_ => {
          request.common(uri, {id}).then(_ => {
            this.$message.success('删除成功')
            this.onSearch()
          })
        })
      }).catch(_ => {
        this.$message.error('抱歉，您没有权限执行此操作')
      })
    },
    resetSearch () {
      this.$refs[this.refSearchForm].resetFields()
    },
    getExportData (params) {
      return request.page('getCompanyBankAccountTable', params)
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getExportData,
        requestParams: this.search,
        getResponseData: (data) => {
          return data
        }
      })
    },
    closeDialog () {
      this.dialogVisible = false
      this.dialogId = 0
    },
    closeDialogRefresh () {
      this.closeDialog()
      this.$router.go(0)
    },
  },
}
</script>


<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/company-bank-account/pages/CompanyAccountTable.vue